import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within a ThemeProvider');
  return context;
};

// === DARK MODE TEMPORARILY DISABLED ===
// To re-enable: restore the previous version of this file from git history.
// While disabled, the app is locked to light mode regardless of system
// preference or saved localStorage value.
const FORCE_LIGHT = true;

export const ThemeProvider = ({ children }) => {
  const isDark = FORCE_LIGHT ? false : (() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  })();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
    if (FORCE_LIGHT) {
      // Make sure no stale value haunts users when we flip the flag back later.
      localStorage.setItem('theme', 'light');
    }
  }, []);

  // No-op while light is forced, so any UI still wired to it just does nothing.
  const toggleTheme = () => {
    if (!FORCE_LIGHT) {
      // re-enable code path lives in git history
    }
  };

  return (
    <ThemeContext.Provider value={{ isDark, theme: 'light', toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
